import { helpPageLink } from 'constants/values';

export const iframeHelpLink = brand => {
  let currentBrand = brand === 'MI' ? 'minivideolist' : 'bmwvideolist';
  let modifiedLink = helpPageLink.replace('bmwvideolist', currentBrand);
  return modifiedLink;
};
